const schema = () => ({
  type: "object",
  required: ["title", "alias"],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
      minLength: 2,
      maxLength: 80,
    },
    alias: {
      type: "string",
      title: "اسلاگ",
      minLength: 2,
      maxLength: 80,
    },
    type: {
      type: "string",
      title: "نوع",
    },
    color: {
      type: "string",
      title: "رنگ",
    },
    details: {
      title: "جزییات",
      type: "string",
      minLength: 3,
      maxLength: 240,
    },
  },
});

export default schema;
